import React from "react";

type TabPanelProps = React.HTMLAttributes<HTMLDivElement> & {
  value: string | number;
  index: string | number;
};

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
      className="rp-tab-panel"
    >
      {children}
    </div>
  );
}

export default TabPanel;
